<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchDamageReport"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.consumptionList.length > 0 && this.$store.getters.modules.includes('5.38')">
              <img src="../../../../static/img/excel.png" style="margin-left: 90em;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="consumptionLists" dataKey="id" ref="dt"
                       :paginator="true"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-gridlines editable-cells-table"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']"/>
                </template>
              </Column>
              <Column header="Damage No" :sortable="true" field="damageNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['damageNo']"/>
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']"/>
                </template>
              </Column>
              <Column header="Total" bodyStyle="text-align: right" :sortable="true" field="totalBillAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                </template>
              </Column>
              <Column header="Action" headerStyle="width:11em">
                <template #body="slotProps">
                  <Button icon="pi pi-pencil" v-if="enableEdit" @click="editSalesOrder(slotProps.data)"  v-tooltip.top="'Edit'"
                          class="btn btn-success pull-right"/>
                  <Button v-else disabled @click="editSalesOrder(slotProps.data)" class="btn btn-success pull-right" v-tooltip.top="'Edit'"
                          icon="pi pi-pencil"/>
                  <Button v-if="enableDelete" class="btn btn-danger pull-left" v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <Button v-else disabled class="btn btn-danger pull-left"  v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <Button class="btn btn-primary" @click="viewPIVDetail(slotProps.data)" icon="pi pi-eye" v-tooltip.top="'View Details'"/>
                  <Button class="btn btn-info" @click="exportToPdf(slotProps.data.id)" icon="pi pi-print" v-tooltip.top="'Print'"/>
                </template>
              </Column>
            </DataTable>
            <!-- <button type="submit" class="btn btn-success pull-left"    style="margin: 1% 0% 0% 88%;"  id="action" @click.prevent="expexportToPdfOrderortToPdf()">
                    {{'Print Selected Orders'}}</button> -->
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'

export default {
  name: 'salesOrderReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      consumptionList: [],
      loading: false,
      dialogShow: false,
      selectedProduct1: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForOrderPrint: [],
      selectedSalesOrderId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      inventoryHeaderId: null,
      enableEdit: false,
      enableDelete: false
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    consumptionLists() {
      return this.$store.state.sales.consumptionLists
    }
  },
  methods: {
    async searchDamageReport() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadConsumptionLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.consumptionList = []
      } else {
        this.consumptionList = resp.data.data
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        orderNo: data.orderNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        vatTypeEnum: data.vatTypeEnum
      }
      this.$router.push({name: 'sales Detail Report', params: {salesHeaderObj: PIHdata}})
    },
    showReasonDialog(data) {
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.ecommerceStatus
      if (data.ecommerceStatus === 'Hold' || data.ecommerceStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.ecommerceStatus
      }
      if (data.ecommerceStatus === 'Completed') {
        this.reason = '-'
        this.updateOrderStatus()
      }
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    async updateOrderStatus() {
      let data = {
        inventoryHeaderId: this.inventoryHeaderId,
        statusType: this.ecommerceStatusData,
        reason: this.reason
      }
      let resp = await this.$store.dispatch('updateStatusOfdOrder', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.ecommerceStatusDialog = false
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesOrder' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesOrder.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForOrderPrint.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForOrderPrint,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForOrderPrint + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    columnNames() {
      for (let i = 1; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editSalesOrder(data) {
      this.$router.push({name: 'Sales Order', params: {salesOrder: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForOrderPrint.includes(data)) {
        this.idsForOrderPrint.push(data)
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 3000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesOrder', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.consumptionLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// damageReport.vue?69920fe3